export default {"src":"/pro/_next/static/media/aster.ab426b85.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};